import React from 'react';

const MetricCard = React.memo(({ value, label, dateRange }) => (
  <div className="metric-card">
    <div className="metric-value">{value}</div>
    <div className="metric-label">{label}</div>
    <div className="chart-subtitle">{dateRange}</div>
  </div>
));

export default MetricCard;
